import { render, staticRenderFns } from "./bathremovacompant.vue?vue&type=template&id=6f0b1afa&scoped=true"
import script from "./bathremovacompant.vue?vue&type=script&lang=js"
export * from "./bathremovacompant.vue?vue&type=script&lang=js"
import style0 from "./bathremovacompant.vue?vue&type=style&index=0&id=6f0b1afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b1afa",
  null
  
)

export default component.exports